import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {}

export const ProjectCodeTooltipContent: FC<Props> = () => {
  return (
    <div>
      <Txt sizeType="s">
        社内でのプロジェクトの管理コードがあれば入力して社内管理に活用ください。
      </Txt>
      <Txt sizeType="s" className="tw-text-[#91939B]">
        ※半角英数字30文字以内
        <br />
        ※他プロジェクトと重複した文字列は使用できません。
      </Txt>
    </div>
  )
}
